import React from "react";

import styled from "styled-components/macro";

import { useCategoryCardContext } from "Dashboard/DashboardCards/DashboardCards";

import Button from "../Sections/Button";
import Card from "../Sections/Card";
import Description from "../Sections/Description";
import Icon from "../Sections/Icon";
import ProgressBar from "../Sections/ProgressBar";
import Subtitle from "../Sections/Subtitle";
import Title from "../Sections/Title";

const FullWidth = () => {
  const {
    ID,
    title,
    description,
    buttonFunc,
    buttonText,
    progressBarPercent,
    progressBarLabel,
    customizations: { subTitlePosition = "bottom" } = {},
    isMobile,
  } = useCategoryCardContext();

  const hasRightContent =
    (buttonFunc && buttonText) || (progressBarPercent && progressBarLabel);

  return (
    <Card key={ID}>
      <LeftContent $isFullWidth={isMobile || !hasRightContent}>
        <Header>
          <Icon />
          {title && (
            <Titles>
              {subTitlePosition === "top" && <Subtitle />}
              <Title />
              {subTitlePosition === "bottom" && <Subtitle />}{" "}
              {description && (
                <DescriptionWrapper>
                  <Description />
                </DescriptionWrapper>
              )}
            </Titles>
          )}
        </Header>
      </LeftContent>

      {hasRightContent && (
        <RightContent $isFullWidth={isMobile}>
          {progressBarPercent && progressBarLabel && (
            <ProgressBarWrapper $isFullWidth={isMobile}>
              <ProgressBar />
            </ProgressBarWrapper>
          )}
          {buttonFunc && buttonText && (
            <ButtonWrapper>
              <Button />
            </ButtonWrapper>
          )}
        </RightContent>
      )}
    </Card>
  );
};

const Header = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
`;

const LeftContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  width: ${({ $isFullWidth }) => ($isFullWidth ? "100%" : "70%")};
`;

const Titles = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 10px;
`;

const RightContent = styled.div`
  width: ${({ $isFullWidth }) => ($isFullWidth ? "100%" : "30%")};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const ProgressBarWrapper = styled.div`
  width: 100%;
`;

const ButtonWrapper = styled.div`
  margin-top: 0.5rem;
  width: 100%;
`;

const DescriptionWrapper = styled.div`
  margin-top: 0.5rem;
  line-height: 1rem;
`;

export default FullWidth;
